module.exports = __webpack_public_path__ + "static/img/fgbg1-10.1c63d2b.png";


//////////////////
// WEBPACK FOOTER
// ./static/feige/fgbg1-10.png
// module id = 188
// module chunks = 0